import { EJTypes } from '../../../cimsPage/instances/ej'
import { Types } from '../../common'

const types = Types({
  page: EJTypes,
  create: 'dd648192-0b2d-4bd9-9f41-c615902ea750',
  view: '3ff9bbe5-a674-46c9-85aa-092e784077f9',
  edit: '47517a55-babc-416f-90d4-c7909a324c6a',
  removeRestore: '4cbcf780-af5f-456f-8f04-df47eebc45e3',
})

export const CreateEJType = types.Create
export const ViewEJType = types.View
export const EditEJType = types.Edit
export const RemoveRestoreEJType = types.RemoveRestore

export type EJTypePermission =
  | typeof CreateEJType
  | typeof ViewEJType
  | typeof EditEJType
  | typeof RemoveRestoreEJType
